import S from 's-js';
import { SArray as ArraySignal } from 's-array';
import { Measurement } from 'data/models/Measurement';
import { Price, ImmutablePrice } from 'data/models/Price';

// TH 05/01/2017 -- Common model-layer functionality for working w/ charges and groups of charges.

export function NumberOfUnits({ Quantity, Unit } : {
    Quantity : Measurement,
    Unit : Measurement
}) {
    const quantity = Quantity.convert(Unit.UOM());
    return quantity.Num() / Unit.Num();
}

export function TotalPriceForCharge({ Quantity, Unit, UnitPrice } : {
    Quantity : Measurement,
    Unit : Measurement,
    UnitPrice : Price
}) {
    return new ImmutablePrice({
        Num: () => NumberOfUnits({ Quantity, Unit }) * UnitPrice.Num(),
        Cur: UnitPrice.Cur
    });
}

// defaultCurrency -- Currency to use when list of charges is empty.
// places -- Rounding to apply. Note that rounding is applied to individual charges before summing to total.
//           This is for applications where it's important to make sure that a bill/invoice balances.
export function TotalPriceForCharges(charges : ArraySignal<{ Total : ImmutablePrice }>, defaultCurrency : () => string, places? : number) {
    const subtotals = places === undefined ? charges.map(c => c.Total) : charges.map(c => c.Total.roundToNPlaces(places)),
        total = S(() => {
            let subs = subtotals(),
                t = subs.length === 0 ? new ImmutablePrice({
                    Num: () => 0,
                    Cur: defaultCurrency
                }) : subs[0];

            for (let i = 1; i < subs.length; i++) {
                // TH 05/01/2017 -- NOTE: This will throw if the currencies don't all match.
                // That's intentional.
                t = t.add(subs[i]);
            }

            return t;
        });

    return new ImmutablePrice({
        Num: () => total().Num(),
        Cur: () => total().Cur()
    });
}


// WEBPACK FOOTER //
// ./data/models/Charge.ts